module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-radio-group"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-9f4a1b9a"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/radio/src/radio-group.vue
// module id = 275
// module chunks = 0